export const M1_UNIT_1 = {
  id: "m1-u1-s1",
  title: "Unit 1: Introducing Yourself",
  iconType: "idea",
  grammarText: "Unit focus: greetings + saying your name (I am / My name is) + contractions (I'm / My name's) + spelling your name (How do you spell…?).",
  grammarImage: "/grammar/m1-grammar.jpg",
  sets: [
    {
id: "u1-set1",
title: "Set 1: Welcome to EducaT México",
context: `*Primer día de clase en EducaT México*

Llegas a recepción de tu nueva escuela de inglés. La recepcionista te sonríe y te saluda. 
Tu objetivo hoy: presentarte con seguridad en inglés.

*First day of class at EducaT Mexico*

You arrive at the reception desk in your new English school. The receptionist smiles and says hello.
Your goal today: introduce yourself confidently in English.`,

questions: [
  {
    type: "match",
    q: "Empareja el saludo con su significado:",
    pairs: [
      { left: "Hello!", right: "Hola (formal)." },
      { left: "Hi!", right: "Hola (informal)." },
      { left: "Good morning!", right: "Buenos días." },
      { left: "Nice to meet you!", right: "Mucho gusto." }
    ],
    a: "completed",
    successTip: "Hello funciona casi siempre; Hi es más casual."
  },
  {
    type: "match",
    q: "Empareja la estructura con su traducción:",
    pairs: [
      { left: "I am Carlos.", right: "Yo soy Carlos." },
      { left: "My name is Carlos.", right: "Mi nombre es Carlos." },
      { left: "Good afternoon!", right: "Buenas tardes!" },
      { left: "Good evening!", right: "Buenas noches!" }
    ],
    a: "completed",
    successTip: "I am / I'm y My name is / My name's son formas básicas para presentarte."
  },
  {
    type: "order",
    q: "Acabas de llegar a recepción. Ordena las palabras para presentarte:",
    words: ["Hi!", "I'm", "Carlos."],
    a: "Hi! I'm Carlos.",
    extra: ["am","is","are"],
    tip: "'I'm' es la contraccion de 'I am'."
  },
  {
    type: "mc",
    q: "Completa la frase: Hello! I ___ Carlos.",
    options: ["am", "is", "are"],
    a: "am",
    tip: "Con I siempre usas am → I am / I'm."
  },
  {
    type: "input",
    q: "La recepcionista te pide tu nombre, te pregunta: What's your name?\n Completa: My ____ is Carlos López.",
    a: "name",
    tip: "Estructura base: My name is + nombre."
  },
  {
    type: "mc",
    q: "La recepcionista confirma tu nombre: '___ you Carlos López?'",
    options: ["Are", "Is", "Am"],
    a: "Are",
    tip: "Con you se usa are → Are you Carlos López?"
  },
{
    type: "match",
    q: "Empareja las frases:",
    pairs: [
      { left: "I", right: "am Carlos" },
      { left: "My name", right: "is Carlos" },
      { left: "What is", right: "your name?" },
      { left: "Are", right: "you Carlos?" }
    ],
    a: "completed",
    successTip: "Para sonar mas natural te recomiendo usar contracciones."
  },
 {
    type: "order",
    q: "La recepcionista te da la mano. Traduce: Encantada de conocerte",
    words: ["Nice", "to", "meet", "you."],
    a: "Nice to meet you.",
   extra: ["morning","good"],
    successTip: "Tambien puedes decir 'Pleased to meet you'."
  },
  {
    type: "mc",
    q: "Responde a la recepcionista: 'Nice to meet you!'",
    options: ["Nice to meet you, too.", "Good morning!", "I am Carlos."],
    a: "Nice to meet you, too.",
    tip: "Nice to meet you, too. (Igualmente / el gusto es mío)."
  },
  {
    type: "order",
    q: "Traduce: Buenos dias, mi nombre es Carlos. Mucho gusto.",
    words: ["Good", "morning.", "My", "name", "is", "Carlos.", "Nice", "to", "meet", "you."],
    a: "Good morning! My name is Carlos. Nice to meet you.",
    successTip: "Ahora practica usando tu nombre!"
  }
]
  },

    {
      id: "m1-u1-s2",
      title: "Set 2: Coffee Line",
      context: "`*Cafetería EducaT*\n\nCompañero: Hey! My name's Leo. What's your name? \n Classmate: Hey! Hola! Soy Leo. ¿Como te llamas?\n\n*EducaT café*\n\nClassmate: Hey! My name's Leo. What's your name?`",
      
      questions: [
        {type: "match", q: "Formal vs informal:", pairs: [{left: "Hello", right: "Hi"}, {left: "Goodbye", right: "Bye"}, {left: "Thank you", right: "Thanks"}, {left: "Yes", right: "Yeah"}], a: "completed", successTip: "THANKS! UK: 'Cheers!' US: 'Thanks a bunch!' 😊"},
        {type: "order", q: "Traduce: '¡Hola! Soy Leo.'", words: ["Hey!", "I'm", "Leo."], a: "Hey! I'm Leo.", extra: ["Bye", "Thanks"], tip: "I'm = I am."},
        {type: "mc", q: "Usa la contraccion: I am → ___", options: ["I'm", "I's", "Iam"], a: "I'm", tip: "I + am = I'm (nunca I's)."},
        {type: "mc", q: "Usa la contraccion: My name is → ___", options: ["My name's", "My names", "Mynames"], a: "My name's", tip: "My name is → My name's."},
        {type: "input", q: "Completa: What _____ your name?", a: "is", alts: ["'s","s"], tip: "'s = is (contracción)."},
        {type: "match", q: "Match contractions:", pairs: [{left: "I'm", right: "I am"}, {left: "You're", right: "You are"}, {left: "name's", right: "name is"}, {left: "Thanks", right: "Thank you"}], a: "completed", successTip: "SPEED TALK! Natives say 'namez' fast. Listen! 🎧"},
        {type: "order", q: "Traduce: '¡El gusto es mío!'", words: ["Nice", "to", "meet", "you", "too."], a: "Nice to meet you too.", extra: ["see", "I"], tip: "too = también."},
        {type: "mc", q: "Como dices 'Gracias':", options: ["Thanks!", "Hello", "Goodbye"], a: "Thanks!", successTip: "Cheers! = thanks (UK pub)."},
        {type: "input", q: "___ you Leo? -Yeah, I am.", a: "Are", successTip: "YEAH! Informal 'yes' everywhere."},
        {type: "mc", q: "Full casual: Hey! _____ Leo. Nice to meet ya!", options: ["I are", "My name's", "My am"], a: "My name's", successTip: "YA! US slang for 'you'. En US decir 'ya' es igual que 'you'." }
      ]
    },

    // SET 3: Classroom Intros (preguntas básicas)
    {
      id: "m1-u1-s3",
      title: "Set 3: Introducing Yourself in Class",
      context: `*Aula EducaT*\n\nProf. Bribark: "Hoy vamos a presentarnos."\n\n*EducaT classroom*\n\nMr. Bribark: "Today we're going to introduce ourselves."`,
      questions: [
        {type: "match", q: "Pregunta → traducción:", pairs: [{left: "What is your name?", right: "¿Cuál es tu nombre?"}, {left: "Are you Carlos?", right: "¿Eres Carlos?"}, {left: "How do you spell?", right: "¿Cómo deletreas?"}, {left: "Nice to meet you", right: "Mucho gusto"}], a: "completed"},
        {type: "order", q: "Traduce: '¿Cómo te llamas?'", words: ["What", "is", "your", "name?"], a: "What is your name?", tip: "What's = What is."},
        {type: "mc", q: "Respuesta a 'What is your name?'", options: ["My name's Ana.", "I'm here.", "On Monday."], a: "My name's Ana."},
        {type: "mc", q: "Completa: ___ your name?", options: ["What is", "What are", "Where is"], a: "What is"},
        {type: "input", q: "Responde: What's your name? -I ___ Ana.", a: "'m",alts: ["am","m"], tip: "I'm + nombre = My name's + nombre."},
        {type: "match", q: "Pregunta → respuesta:", pairs: [{left: "What's your name?", right: "I'm Carlos."}, {left: "Nice to meet you", right: "Nice to meet you too."}, {left: "Are you Ana?", right: "Yes I am."}, {left: "How do you spell?", right: "A-N-A."}], a: "completed", successTip: "A veces escucharas: US: 'Whaddya name?' UK: 'What's yer name?'👂"},
        {type: "order", q: "Traduce: 'Sí, soy.'", words: ["Yes,", "I", "am."], a: "Yes, I am.",extra: ["name","are"], successTip: "No olvides completar con 'I am'."},
        {type: "mc", q: "Completa:'My teacher is ____'", options: ["Mr. Bribark", "Name", "I'm"], a: "Mr. Bribark"},
        {type: "input", q: "Are ___ Carlos? -Yes, I am.", a: "you"},
        {type: "order", q: "Traduce 'Cómo te llamas?'", words: ["What's", "your", "name"], a: "What's your name?",alts: ["Where","You"], tip: " Where = Donde? 💬"}
      ]
    },

    // SET 4: Spelling Time
    {
      id: "m1-u1-s4",
      title: "Set 4: Clarifying information",
      context: `*Oficina de registros EducaT*\n\nAdmin: "Necesito confirmar una informacion."\n\n*EducaT registration*\n\nAdmin: "I need to double check some information."`,
      questions: [
        {type: "match", q: "Une los pares:", pairs: [{left: "first name", right: "nombre"}, {left: "last name", right: "apellido"}, {left: "full name", right: "Nombre completo"}, {left: "spell", right: "deletrear"}], a: "completed", successTip: "En US: first name y last name, pero en UK: forename y surname."},
        {type: "mc", q: "Responde a 'How do you spell Carlos?':", options: ["C-A-R-L-O-S.", "I'm Carlos.", "Nice to meet you."], a: "C-A-R-L-O-S."},
        {type: "order", q: "Traduce: '¿Cómo deletreas tu nombre?'", words: ["How", "do", "you", "spell", "your", "name?"], a: "How do you spell your name?",extra: ["lastname","my"], tip: "Spell = deletrear."},
        {type: "input", q: "-Spell your ___ name. - 'L-O-P-E-Z':", a: "last",alts: ["last","surname","sur"]},
        {type: "mc", q: "Last name =", options: ["apellido", "nombre", "edad"], a: "apellido"},
        {type: "match", q: "Match names:", pairs: [{left: "Carlos", right: "first"}, {left: "Lopez", right: "last"}, {left: "Carlos Lopez", right: "full"}, {left: "Carl", right: "nickname"}], a: "completed",successTip: "Nickname = apodo (informal)."},
        {type: "order", q: "Traduce: 'Mi apellido es Park.'", words: ["My", "last", "name", "is", "Park."], a: "My last name is Park.", extra: ["first","full"]},
        {type: "mc", q: "How do you ___ it?", options: ["spell", "say", "write"], a: "spell"},
        {type: "input", q: "What's your _____ ____? -Carlos Lopez.", a: "full name"},
        {type: "order", q: "Traduce: 'Como deletreas tu apellido?'", words: ["How", "do", "you", "spell", "your", "last", "name?"], a: "How do you spell your last name?", extra: ["please","my"], successTip: "Si tienes 2 nombres usa middle name. ✈️"}
      ]
    },

    // SET 5: Registration Form
    {
      id: "m1-u1-s5",
      title: "Set 5: Registration Form",
      context: `*Formulario EducaT*\n\nLlena el formulario de inscripción.\n\n*EducaT form*\n\nFill out the registration form.`,
      questions: [
        {type: "match", q: "Form fields:", pairs: [{left: "First name", right: "Carlos"}, {left: "Last name", right: "Lopez"}, {left: "Full name", right: "Carlos Lopez"}, {left: "Nickname", right: "Carl"}], a: "completed"},
        {type: "mc", q: "My first name ___ Ana.", options: ["is", "am", "are"], a: "is"},
        {type: "mc", q: "My last name ___ Park.", options: ["is", "am", "are"], a: "is"},
        {type: "order", q: "Traduce: 'Esta es mi tarjeta.'", words: ["This", "is", "my", "ID", "card."], a: "This is my ID card.", tip: "ID = identification."},
        {type: "input", q: "My full name ___ Ana Park.", a: "is"},
        {type: "mc", q: "No, my name is Ana and my ___ is Park.", options: ["last name", "full name", "nickname"], a: "last name"},
        {type: "match", q: "Tipos de nombres:", pairs: [{left: "first", right: "primer"}, {left: "last", right: "apellido"}, {left: "full", right: "completo"}, {left: "Middle", right: "segundo"}], a: "completed", successTip: "MS.! Neutral title (US/UK). Mrs.= Señora, Miss= Señorita (old-fashioned). 👩‍🏫"},
        {type: "order", q: "Traduce: 'Mi nombre completo es...' ", words: ["My", "full", "name", "is"], a: "My full name is", extra: ["Park","nickname"], tip: "Full name = nombre completo."},
        {type: "input", q: "My ___ name is Carlos, but my last name Lopez.", a: "First"},
        {type: "order", q: "Traduce: 'Mi nombre es Carlos, pero mi apellido es Lopez.'", words: ["My", "first", "name", "is", "Carlos", "but", "my", "last", "name", "is", "Lopez."], a: "My first name is Carlos, but my last name is Lopez.", successTip: "FORM READY! 'Surname?' (UK) or 'Last name?' (US). 📝"}
      ]
    },
    // SET 6: Meet the Teacher (títulos + confirmación)
    {
      id: "m1-u1-s6",
      title: "Set 6: Meet the Teacher",
      context: `*Inicia la clase en EducaT*\n\nProfesora Park: "Good morning! I'm Ms. Park."\nPractice titles/responses.\n\n*The class starts in EducaT*\n\nMs. Park: "Good morning! I'm Ms. Park."`,
      questions: [
        {type: "order", q: "Traduce: 'Buenos días, soy la Sra. Park.'", words: ["Good", "morning!", "I'm", "Ms.", "Park."], a: "Good morning! I'm Ms. Park.", successTip: "MS.! es neutral (US/UK). Mrs. se usa para señoras, Miss se usa para señoritas. 👩‍🏫."},
        {type: "mc", q: "You ___ Ms. Park.", options: ["are", "is", "am"], a: "are", tip: "You + are."},
        {type: "mc", q: "I ___ Carlos.", options: ["am", "is"], a: "am"},
        {type: "match", q: "Titles:", pairs: [{left: "Mr.", right: "Señor"}, {left: "Mrs.", right: "Señora casada"}, {left: "Ms.", right: "Neutral"}, {left: "Miss", right: "Señorita"}], a: "completed"},
        {type: "mc", q: "Responde al saludo: Nice to meet you, ___ Park.", options: ["Ms.", "Mrs.", "Miss"], a: "Ms.", tip: "Ms. = neutral."},
        {type: "order", q: "Traduce: '¿Eres la Sra. Park?'", words: ["Are", "you", "Ms.", "Park?"], a: "Are you Ms. Park?", tip: "Are + you."},
        {type: "mc", q: "Responde:'Are you Carlos?' →", options: ["Yes, I am.", "Yes, you are.", "Yes, he is."], a: "Yes, I am.", tip: "Yes + sujeto + verbo."},
        {type: "input", q: "Yes, ___ am.", a: "I"},
        {type: "match", q: "Question → Answer:", pairs: [{left: "Are you Carlos?", right: "Yes, I am."}, {left: "What's your name?", right: "My name's Mia."}, {left: "How do you spell?", right: "M-I-A."}], a: "completed", successTip: "YES I AM! Short & sweet. UK: 'Yeah I am.' Casual! 👍"},
        {type: "order", q: "Traduce: 'Mucho gusto de conocerte, Ms. Park!'", words: ["Nice", "to", "meet", "you,", "Ms.", "Park."], a: "Nice to meet you, Ms. Park.", successTip: "Deja de decir 'Teacher' y comienza a usar Mr. o Ms. con tus profesores. 👏"}
      ]
    },

    // SET 7: New Classmates (plurales/we/you)
    {
      id: "m1-u1-s7",
      title: "Set 7: New Classmates",
      context: `*Ronda de presentaciones*\n\n"Es hora de practicar con tus compañeros y conocer gente nueva.\n\n*Introduction round*\n\nTime to practice with classmates and meet new people."`,
      questions: [
        {type: "match", q: "Pronoun + to be:", pairs: [{left: "I", right: "am"}, {left: "You", right: "are"}, {left: "He/She", right: "is"}, {left: "We", right: "are"}], a: "completed", tip: "We/you = are."},
        {type: "mc", q: "Carlos ___ here.", options: ["is", "am"], a: "is"},
        {type: "mc", q: "Carlos and Ana ___ students.", options: ["are", "is"], a: "are"},
        {type: "order", q: "Traduce: 'Somos compañeros.'", words: ["We", "are", "classmates."], a: "We are classmates.", tip: "We + are + plural."},
        {type: "input", q: "We ___ in Level 1.", a: "are"},
        {type: "mc", q: "You ___ ready.", options: ["are","am", "is"], a: "are", successTip: "You puede ser singular o plural."},
        {type: "match", q: "Contractions plural:", pairs: [{left: "We're", right: "We are"}, {left: "You're", right: "You are"}, {left: "They're", right: "They are"}], a: "completed", successTip: "WE'RE! Group talk: We're all here! US/UK same."},
        {type: "order", q: "Traduce: 'Ustedes son estudiantes.'", words: ["You", "are", "students."], a: "You are students.", extra: ["is", "am"], tip: "You + are. En plural o singular"},
        {type: "mc", q: "'We're classmates' =", options: ["We are", "You are", "They is"], a: "We are"},
        {type: "order", q: "Traduce: Hola, soy Leo. Nosotros somos companeros!", words: ["Hi","I'm","Leo","We're","classmates!"], a: "Hi, I'm Leo. We're classmates!", extra: ["am","is"], successTip: "GROUP VIBE! 'We're in this together!' Team English! 🤝"}
      ]
    },

    // SET 8: Mini Reading (pasajes)
    {
      id: "m1-u1-s8",
      title: "Set 8: Mini Conversations",
      context: `*Diálogos en la clase*\n\nPractica con conversaciones reales.\n\n*Class dialogues*\n\nPractice with real conversations.`,
      questions: [
        {type: "passage", passage: `"Hi class! I'm Ms. Park. My name's Emma Park."\nStudent: "Nice to meet you, Ms. Park!"`},
        {type: "mc", q: "What's the teacher's last name:", options: ["Park", "Emma","Ms"], a: "Park"},
        {type: "order", q: "Que habria respondido Ms park?:", words: ["Nice", "to", "meet", "you","too"], a: "Nice to meet you too", extra: ["last","My","name"]},
        {type: "passage", passage: `"What's your name? \n\nI'm Carlos. \n\nHow do you spell it?\n\n C-A-R-L-O-S."`},
        {type: "mc", q: "'What's' =", options: ["What is", "Where is", "When is"], a: "What is", tip: "'Where = donde', 'When = cuando'."},
        {type: "input", q: "Nice to ____ ____ Carlos.", a: "meet you"},
        {type: "passage", passage: `"Are you Ana? \n\nYes, I am. My full name's Ana Garcia."`},
        {type: "mc", q: "Who is she?", options: ["She am Ana", "She are Ana", "She's Ana"], a: "She's Ana", tip: "She + is = She's"},
        {type: "order", q: "Traduce: 'Mi nombre completo es...'", words: ["My", "full", "name's"], a: "My full name's", extra: ["Ana","first"]},
        {type: "match", q: "Match diálogos:", pairs: [{left: "What's your name?", right: "I'm Carlos."}, {left: "How do you spell?", right: "C-A-R-L-O-S."}, {left: "Are you Ana?", right: "Yes, I am."}, {left: "Nice to meet you!", right: "Nice to meet you too!"}], a: "completed", successTip: "Introduce yourself with confidence! 🗣️"}
      ]
    },

    // SET 9: Grammar Police (correcciones errores)
    {
      id: "m1-u1-s9",
      title: "Set 9: Fix Common Errors",
      context: `*Correcciones en clase*\n\nLa profesora corrige errores en la clase.\n\n*Class corrections*\n\nThe teacher corrects mistakes in class.`,
      questions: [
        {type: "mc", q: "Fix: 'I is Carlos.'", options: ["I am Carlos.", "I are Carlos."], a: "I am Carlos.", tip: "I → am (no is)."},
        {type: "mc", q: "Fix: 'My name am Ana.'", options: ["My name is Ana.", "My name are Ana."], a: "My name is Ana."},
        {type: "mc", q: "Fix: 'What your name is?'", options: ["What is your name?", "What are your name?"], a: "What is your name?"},
        {type: "order", q: "Fix order: Nice ___ ___ you.", words: ["to", "meet"], a: "to meet", tip: "Nice TO meet (no 'nice meet')."},
        {type: "mc", q: "Fix: 'You is ready.'", options: ["You are ready.", "You am ready."], a: "You are ready."},
        {type: "input", q: "Fix: My name ___ Carlos.", a: "is"},
        {type: "mc", q: "Common error: 'How spell you?' →", options: ["How do you spell?", "How you spell?"], a: "How do you spell?"},
        {type: "match", q: "Mistake → Correction:", pairs: [{left: "I is", right: "I am"}, {left: "name am", right: "name is"}, {left: "You is", right: "You are"}, {left: "Nice meet", right: "Nice to meet"}], a: "completed", successTip: "ERROR HUNTER! Hispanic traps fixed: I=am, name=is, you=are. Pro now! 🛡️"},
        {type: "mc", q: "'Are you Carlos?' → No, ___ Ana.", options: ["I'm", "I is","I are"], a: "I'm"},
        {type: "order", q: "Traduce: 'Si, yo soy Carlos.'", words: ["Yes,", "I", "am", "Carlos."], a: "Yes, I am Carlos.", extra: ["are","name"], successTip: "To level up! 'Mistake' es un error humano y 'error' es un error de programación. 🚀"}
      ]
    },

    // SET 10: Real-Life Practice (integración total)
    {
      id: "m1-u1-s10",
      title: "Set 10: Real-Life Mastery",
      context: `*Escenario real: Llegada a la nueva escuela*\n\n*Real scenario: Arrival at the new school*.`,
      questions: [
        {type: "order", q: "Full intro:", words: ["hello", "my", "name's", "Carlos", "Lopez"], a: "Hello! My name's Carlos Lopez.", extra: ["are","is"], tip: "Name's + full name."},
        {type: "mc", q: "Ms. Park asks: 'How do you spell your last name?' →", options: ["L-O-P-E-Z.", "My name Lopez.","Lopez"], a: "L-O-P-E-Z.", tip: "Spell = deletrear."},
        {type: "input", q: "'Are you Carlos?' -Yes, ___ ___.", a: "I am"},
        {type: "match", q: "Situación → frase:", pairs: [{left: "Nice to meet you!", right: "Nice to meet you, too!"}, {left: "What's your name?", right: "My name is Carlos."}, {left: "How do you spell it?", right: "C-A-R-L-O-S."}, {left: "What's your nickname?", right: "Charlie"}, {left: "Are you the new student?", right: "Yes, I am."}], a: "completed"},
        {type: "mc", q: "Como responderias a:'Hi! I'm Leo.'", options: ["Hi Leo! Nice to meet you!", "She is Ana.", "Yes, I am"], a: "Hi Leo! Nice to meet you!", tip: "Full mirror reply."},
        {type: "order", q: "'Disculpe, ¿cómo deletreas?'", words: ["Excuse", "me,", "how", "do", "you", "spell?"], a: "Excuse me, how do you spell?", tip: "Excuse me = cortesía."},
        {type: "input", q: "My full name ___ Ana Park.", a: "is", alts: ["'s","s"], tip: "Full name = nombre completo."},
        {type: "mc", q: "'We're classmates' =", options: ["We are", "You are"], a: "We are"},
        {type: "order", q: "Traduce: Hola Soy Carlos, Mucho gusto", words: ["Hi", "I'm", "Carlos.", "Nice", "to", "meet", "you"], extra: ["is","are"], a: "Hi! I'm Carlos. Nice to meet you!"},
        {type: "match", q: "Final mastery:", pairs: [{left: "Saludo", right: "Hi!/Hello!"}, {left: "Nombre", right: "I'm/My name's"}, {left: "Deletrear", right: "How do you spell?"}, {left: "Frase de cortesia", right: "Nice to meet you too!"}], a: "completed", successTip: "UNIT CONQUERED!🏆"
}
      ]
    }
  ],   
  
  readingSet: {
  id: "m1-u1-reading",
  title: "Set 11: Reading - First Day at School",
  category: "reading",
  questions: [
    {
      type: "passage",
      passage: `*EducaT México - Día 1*\n\n"Hi everyone! My name is Ms. Emma Park. I'm your teacher. My first name is Emma. My last name is Park. Nice to meet you all!"\n\nWelcome to Level 1.`
    },
    {
      type: "mc",
      q: "¿Cuál es el apellido de la maestra?",
      options: ["Park", "Emma", "Ms."],
      a: "Park",
      tip: "Last name = apellido (Park)."
    },
    {
      type: "mc",
      q: "Ms. Park dice: 'Nice to ___ you all!'",
      options: ["meet", "see", "know"],
      a: "meet"
    },
    {
      type: "passage",
      passage: `"Hello class! I'm Carlos Lopez.  \n\n-How do you spell your first name? \n\nC-A-R-L-O-S. \n\n And your last name? \n\nL-O-P-E-Z. I'm a student from Mexico."`
    },
    {
      type: "order",
      q: "Traduce: 'Mi apellido es Lopez'",
      words: ["My", "last", "name", "is", "Lopez."],
      a: "My last name is Lopez.",
      tip: "Last name = apellido."
    },
    {
      type: "mc",
      q: "¿De dónde es Carlos?",
      options: ["Mexico", "USA", "Canada"],
      a: "Mexico"
    },
    {
      type: "passage",
      passage: `"Hi! You're Ana, right? Yes, I am. My name's Ana Garcia. Nice to meet you, Carlos!"\n\nThe class says: "Nice to meet you too!"`
    },
    {
      type: "mc",
      q: "Ana confirma: '___ , I am.'",
      options: ["Yes", "No", "Maybe"],
      a: "Yes"
    },
    {
      type: "input",
      q: "Completa: Nice to meet you ___!",
      a: "too",
      successTip: "TOO! = también. Natives say 'You too!' (US) or 'Likewise!' (UK formal)."
    },
    {
      type: "order",
      q: "Traduce: Mucho gusto de conocerte también.",
      words: ["Nice", "to", "meet", "you,", "too!"],
      a: "Nice to meet you, too!",
      successTip: "FULL INTRO! Now introduce anywhere: Hi! Name's [You]. Spell? Nice to meet ya! 🌍"
    }
  ]
},
reviewSet: {
      id: "m1-u1_review",
      title: "Set 12: Unit Review",
      category: "review",
      questions: [
        {
          type: "match",
          q: "Empareja el pronombre con su forma correcta de 'to be':",
          pairs: [
            { left: "I", right: "am" },
            { left: "You", right: "are" },
            { left: "He / She / It", right: "is" },
            { left: "We / They", right: "are" }
          ],
          a: "completed",
          tip: "Dominar esto es clave para todo el nivel A1."
        },
        {
          type: "mc",
          q: "Conversación:\n— Hi! What's your name?\n— ___\n\n¿Cuál es la respuesta MÁS completa?",
          options: ["My name's Ana Lopez. Nice to meet you!", "Ana.", "I'm here."],
          a: "My name's Ana Lopez. Nice to meet you!",
          tip: "Respuesta completa = nombre completo + cortesía."
        },
        {
          type: "order",
          q: "Ordena las palabras para formar la pregunta:",
          words: ["How", "do", "you", "spell", "your", "last", "name?"],
          a: "How do you spell your last name?",
          tip: "Pregunta clave en formularios y entrevistas."
        },
        {
          type: "mc",
          q: "¿Cuál frase es INCORRECTA?",
          options: ["My name am Carlos.", "I'm Carlos.", "My name is Carlos.", "I am Carlos."],
          a: "My name am Carlos.",
          tip: "My name + is (nunca 'am')."
        },
        {
          type: "input",
          q: "Completa la conversación:\n— Are you Ms. Park?\n— Yes, ____ ____.",
          a: ["I am", "i am"]
        },
        {
          type: "match",
          q: "Empareja la contracción con su forma completa:",
          pairs: [
            { left: "I'm", right: "I am" },
            { left: "You're", right: "You are" },
            { left: "He's / She's / It's", right: "He is / She is / It is" },
            { left: "We're / They're", right: "We are / They are" }
          ],
          a: "completed"
        },
        {
          type: "mc",
          q: "En un aeropuerto:\n— Excuse me, how do you spell your first name?\n— ___\n\n¿Cuál es la respuesta correcta?",
          options: ["C-A-R-L-O-S.", "My first name is Carlos.", "I am Carlos."],
          a: "C-A-R-L-O-S.",
          tip: "Cuando piden spelling, deletrea letra por letra."
        },
        {
          type: "order",
          q: "Ordena las palabras para formar una presentación formal completa:",
          words: ["Good", "morning.", "My", "name", "is", "Ana", "Lopez.", "I'm", "a", "student.", "Nice", "to", "meet", "you."],
          a: "Good morning. My name is Ana Lopez. I'm a student. Nice to meet you.",
          tip: "Estructura: saludo + nombre + ocupación + cortesía."
        },
        {
          type: "mc",
          q: "¿Cuál es el error común de hispanohablantes?",
          options: ["I is Carlos.", "I am Carlos.", "I'm Carlos."],
          a: "I is Carlos.",
          tip: "En español: 'Yo soy'. En inglés: I + am (nunca 'is')."
        },
        {
          type: "match",
          q: "BOSS CHALLENGE: Empareja la pregunta con la respuesta MÁS apropiada:",
          pairs: [
            { left: "What's your full name?", right: "My name is Carlos Alberto Lopez." },
            { left: "How do you spell it?", right: "C-A-R-L-O-S." },
            { left: "Are you a teacher?", right: "No, I'm a student." },
            { left: "Nice to meet you!", right: "Nice to meet you, too!" }
          ],
          a: "completed",
          tip: "¡Excelente! Has completado la Unidad 1. Ya puedes presentarte con confianza en inglés."
        }
      ]
    }
  };
